import { z } from 'zod';

export const TargetStageSchema = z
    .union([z.literal('assign'), z.literal('calculate'), z.literal('send'), z.literal('unknown')])
    .catch('unknown');
// export const TargetStageSchema = z.string();
export type TargetStageTypes = z.infer<typeof TargetStageSchema>;

export const GetTargetStateResponseSchema = z.object({
    stage_current: z.record(TargetStageSchema, z.array(z.number())),
    stage_target: z.record(TargetStageSchema, z.array(z.number())),
    todo: z.record(TargetStageSchema, z.array(z.number())),
    dangling: z.array(z.number()),
});
export type GetTargetStateResponseType = z.infer<typeof GetTargetStateResponseSchema>;
